module.exports = __webpack_public_path__ + "img/mouth-1-4.4a09f21a.svg";